import { render } from "./AccountModalDelete.vue?vue&type=template&id=74202cca"
import script from "./AccountModalDelete.vue?vue&type=script&lang=js"
export * from "./AccountModalDelete.vue?vue&type=script&lang=js"
script.render = render

export default script